<!--
 * @Author: guoyu
 * @Date: 2020-05-28 16:53:16
 * @LastEditors: your name
 * @LastEditTime: 2020-07-17 15:31:33
 * @Description: 满减优惠, 不需要手动选中
-->
<template>
  <div class="full-coupons-container">
    <p class="full-coupons-title">滿贈優惠</p>
    <div class="rule-container">
      <span
        v-for="(o, i) in options"
        :key="'rule-' + i"
        class="one-rule"
      >
        {{ o | parseGiveAway }}
      </span>
    </div>
    <!-- <GeneralCheckbox
      v-model="couponsCount"
      :col="10"
      :options="options"
      valKey="startNum"
      :rowStyle="{ 'justify-content': 'flex-start' }"
      :colStyle="{ 'margin-right': '16px' }"
      @changeItem="changeCount"
    >
      <template v-slot="{ item, checked }">
        <div class="coupons-item" :class="{ checked }">
          滿{{ item.startNum }}贈{{ item.giftNum }}
        </div>
      </template>
    </GeneralCheckbox> -->
  </div>
</template>
<script>
// import GeneralCheckbox from '@/components/common/checkbox/general-checkbox';
export default {
  components: {
    // GeneralCheckbox,
  },
  model: {
    event: 'change',
    prop: 'count',
  },
  props: {
    // TODO:总价
    allPrice: {
      type: Number,
      default: 0,
    },
    // TODO:支付价
    price: {
      type: Number,
      default: 0,
    },
    // 小时数
    count: {
      type: Number,
      default: 1,
    },
    // 满减list
    countCouponsList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
  //   couponsCount() {
  //     if (!Array.isArray(this.countCouponsList)) return;
  //     if (this.count > this.maxCount) return this.maxCount;
  //     let max = 0;
  //     // 返回最大可用優惠
  //     this.countCouponsList.forEach(item => {
  //       if (this.count >= item.startNum && max < item.startNum) {
  //         max = item.startNum;
  //       }
  //     });
  //     return max;
  //   },
  // 緩存最大優惠
    maxCount() {
      let max = 0;
      this.countCouponsList.forEach(item => {
        if (max < item.startNum) {
          max = item.startNum;
        }
      });
      return max;
    },
    options() {
      return Array.isArray(this.countCouponsList) ? this.countCouponsList : [];
    },
  },
  methods: {
    changeCount(item) {
      this.$emit('change', item.startNum);
    },
  },
};
</script>
<style lang="scss" scoped>
.full-coupons-container {
  height: 86px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333333;
  .rule-container {
    display: flex;
    align-items: center;
  }
  .one-rule {
    display: inline-block;
    padding: 0px 3px;
    height: 17px;
    border-radius: 4px;
    border: 1px solid #FC4118;
    font-size: 14px;
    line-height: 17px;
    color: #FC4118;
    margin-left: 8px;
  }
}
.full-coupons-title {
  // padding: 25px 0 20px;
  font-size: 16px;
  font-weight: 500;
}
.coupons-item {
  position: relative;
  overflow: hidden;
  height: 41px;
  padding: 13px 23px;
  border-radius: 4px;
  background: #f6f6f6;
  line-height: 1;
  font-size: 14px;
  color: #333333;
  white-space: nowrap;
}
.checked {
  border: 1px solid #fa006e;
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: -1px;
    right: -1px;
    height: 15px;
    width: 15px;
    background-color: #fa006e;
    border-radius: 0 0 0 4px;
    background-image: url('~@/assets/imgs/white-check.png');
    background-repeat: no-repeat;
    background-size: 8px 6px;
    background-position: center center;
  }
}
@media screen  and (min-width: 600px){
  .full-coupons-container {
    padding: 0;
    border-bottom: 2px solid #F4F4F4;
    color: #333333;
    justify-content: flex-start;
    .full-coupons-title {
      margin-right: 12px;
    }
    .one-rule {
      display: inline-block;
      padding: 5px 6px;
      height: auto;
      background: rgba(255, 93, 64, 0.1);
      border-radius: 4px;
      font-weight: 500;
      font-size: 14px;
      line-height: 14px;
      color: #FF5D40;
      margin-left: 10px;
      box-sizing: content-box;
      border: none;
    }
  }
}
</style>
